var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrescent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06782 19.0711C9.15824 22.9763 15.7901 22.9763 19.8806 19.0711C20.2232 18.7439 19.7663 18.1995 19.2957 18.3103C17.0575 18.8374 14.5936 18.2661 12.8445 16.5962C10.1857 14.0578 10.1857 9.94221 12.8445 7.40381C14.5936 5.73394 17.0575 5.16258 19.2957 5.68972C19.7663 5.80054 20.2232 5.25611 19.8806 4.92893C15.7901 1.02369 9.15824 1.02369 5.06782 4.92893C0.977393 8.83418 0.977394 15.1658 5.06782 19.0711Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrescent);
export default __webpack_public_path__ + "static/media/crescent.0115e23839d64658bf414618cf78c5b4.svg";
export { ForwardRef as ReactComponent };